import { render } from "./SectionHome.vue?vue&type=template&id=55de675b&scoped=true"
import script from "./SectionHome.vue?vue&type=script&lang=js"
export * from "./SectionHome.vue?vue&type=script&lang=js"

import "./SectionHome.vue?vue&type=style&index=0&id=55de675b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55de675b"]])

export default __exports__